<template>
    <footer class="footer" style="background: #172b4d;">
        <div class="container container-lg">
            <div class="row text-white">
                <div class="col-sm-4">
                <router-link class="navbar-brand" to="/">
                    <img src="img/logo.png" alt="" />
                </router-link>
                <h5 class="text-white" style="padding: 10px 0;">One-stop AI Solution</h5>
                <p>Make AI easier than ever</p>
            </div>
        <div class="col-sm-2 text-primary">
          <h5 class="text-uppercase text-white font-weight-light title" style="padding: 10px 0">Solutions</h5>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/solutions/autonomous-driving" class="small text-white" style="font-size:12px">Autonomous Driving</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/solutions/smart-home" class="small text-white" style="font-size:12px">Smart Home</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/solutions/manufacturing" class="small text-white" style="font-size:12px">Manufacturing</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/solutions/smart-retail" class="small text-white" style="font-size:12px">Smart Retail</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/solutions/mobile-apps" class="small text-white" style="font-size:12px">Mobile Apps</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/solutions/robotics" class="small text-white" style="font-size:12px">Robotics</router-link>
          </li>
        </div>
        <div class="col-sm-2 text-primary">
          <h5 class="text-uppercase text-white font-weight-light title" style="padding: 10px 0">Services</h5>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/services/data/collection" class="small text-white" style="font-size:12px">Data Collection</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/services/data/cleaning" class="small text-white" style="font-size:12px">Data Cleaning</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none;">
            <router-link to="/services/data/annotation" class="small text-white" style="font-size:12px">Data Annotation</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/services/data/augmentation" class="small text-white" style="font-size:12px">Data Augmentation</router-link>
          </li>
        </div>
        <div class="col-sm-2 text-primary">
          <h5 class="text-uppercase text-white font-weight-light title" style="padding: 10px 0">Company</h5>
          <li class="nav-item" style=" list-style-type:none">
            <router-link to="/about" class="small text-white" style="font-size:12px">About us</router-link>
          </li>
          <li class="nav-item" style="list-style-type:none">
            <router-link to="/careers" class="small text-white" style="font-size:12px">Careers</router-link>
          </li>
        </div>
        <div class="col-sm-2 text-primary">
          <h5 class="text-uppercase text-white font-weight-light title" style="padding: 10px 0">Contact us</h5>
          <a href = "mailto: info@magicom.io"><p class="small text-white" style="font-size:12px;">info@magicom.io</p></a>
        </div>     
      </div>
      <hr style="border-top: 1px solid gray;">
      <div class="row">
        <div class="col-md-6">    
          <div class="copyright">
              <p class="text-white small" style="font-size:12px;"> Copyright&copy;{{ year }}, Magicom Inc. All rights reserved. </p>
          </div>
        </div>
        <div class="col-md-6 justify-content-end">
              <ul class="nav nav-footer justify-content-end" style="aligh:right">
                  <li class="nav-item text-white" style="list-style-type:none">
                      <router-link to="/terms-of-use" class="small text-white" style="font-size:12px; padding-right:10px">Terms of Use</router-link>
                  </li>
                  <li class="nav-item text-white" style="list-style-type:none">
                      <router-link to="/privacy" class="small text-white" style="font-size:12px">Privacy Policy</router-link>
                  </li>
              </ul>
          </div>
      </div>
    </div>
        
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
